import { Box, Typography, Dialog, DialogActions, DialogTitle, Button } from "@mui/material";
import { useState } from "react";
import { startCase } from "lodash";
import ApiRoundedIcon from "@mui/icons-material/ApiRounded";
import headlessLogos from "../../../../../../../public/images/headlessLogos.jpg";
import hybridLogos from "../../../../../../../public/images/hybridLogos.jpg";
import { InstanceSetting } from "../../../../../../shell/services/types";
import { useUpdateInstanceSettingMutation } from "../../../../../../shell/services/instance";
import { useTranslation } from "react-i18next";
type Props = {
  instanceSetting: InstanceSetting;
};
export const HeadlessSwitcher = ({
  instanceSetting
}: Props) => {
  const {
    t
  } = useTranslation();
  const [selected, setSelected] = useState<"hybrid" | "headless" | null>(null);
  const [updateInstanceSetting, {
    isLoading
  }] = useUpdateInstanceSettingMutation();
  const handleSwitch = () => {
    updateInstanceSetting({
      ...instanceSetting,
      value: selected,
      options: instanceSetting?.options?.replaceAll(",", ";")
    });
  };
  return <>
      <Typography variant="h4" fontWeight={600} sx={{
      mb: 0.5
    }} data-sentry-element="Typography" data-sentry-source-file="HeadlessSwitcher.tsx">
        {t("schema.headlessSwitcherTitle")}
      </Typography>
      <Typography color="text.secondary" data-sentry-element="Typography" data-sentry-source-file="HeadlessSwitcher.tsx">
        {t("schema.headlessSwitcherSubtitle")}
      </Typography>
      <Box mt={3} display="flex" gap={2} maxWidth="1200px" data-sentry-element="Box" data-sentry-source-file="HeadlessSwitcher.tsx">
        <Box borderRadius="8px" width="100%" sx={{
        border: theme => `1px solid ${theme.palette.border}`,
        cursor: "pointer"
      }} onClick={() => setSelected("headless")} data-sentry-element="Box" data-sentry-source-file="HeadlessSwitcher.tsx">
          <Box component="img" borderRadius="8px 8px 0 0" width="100%" src={headlessLogos} data-sentry-element="Box" data-sentry-source-file="HeadlessSwitcher.tsx" />
          <Box p={2} data-sentry-element="Box" data-sentry-source-file="HeadlessSwitcher.tsx">
            <Typography variant="h5" fontWeight={600} sx={{
            mb: 0.5
          }} data-sentry-element="Typography" data-sentry-source-file="HeadlessSwitcher.tsx">
              {t("schema.switchToHeadless")}
            </Typography>
            <Typography color="text.secondary" data-sentry-element="Typography" data-sentry-source-file="HeadlessSwitcher.tsx">
              {t("schema.headlessDescription")}
            </Typography>
          </Box>
        </Box>
        <Box width="100%" borderRadius="8px" sx={{
        border: theme => `1px solid ${theme.palette.border}`,
        cursor: "pointer"
      }} onClick={() => setSelected("hybrid")} data-sentry-element="Box" data-sentry-source-file="HeadlessSwitcher.tsx">
          <Box component="img" borderRadius="8px 8px 0 0" width="100%" src={hybridLogos} data-sentry-element="Box" data-sentry-source-file="HeadlessSwitcher.tsx" />
          <Box p={2} data-sentry-element="Box" data-sentry-source-file="HeadlessSwitcher.tsx">
            <Typography variant="h5" fontWeight={600} sx={{
            mb: 0.5
          }} data-sentry-element="Typography" data-sentry-source-file="HeadlessSwitcher.tsx">
              {t("schema.switchToHybrid")}
            </Typography>
            <Typography color="text.secondary" data-sentry-element="Typography" data-sentry-source-file="HeadlessSwitcher.tsx">
              {t("schema.hybridDescription")}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Dialog open={!!selected} onClose={() => setSelected(null)} fullWidth maxWidth="xs" data-sentry-element="Dialog" data-sentry-source-file="HeadlessSwitcher.tsx">
        <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="HeadlessSwitcher.tsx">
          <Box sx={{
          backgroundColor: "warning.light",
          borderRadius: "100%",
          width: "40px",
          height: "40px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }} data-sentry-element="Box" data-sentry-source-file="HeadlessSwitcher.tsx">
            <ApiRoundedIcon color="error" data-sentry-element="ApiRoundedIcon" data-sentry-source-file="HeadlessSwitcher.tsx" />
          </Box>
          <Typography variant="h5" sx={{
          mt: 1.5
        }} data-sentry-element="Typography" data-sentry-source-file="HeadlessSwitcher.tsx">
            {t("schema.switchWebEngineModeTitle", {
            mode: startCase(selected)
          })}
          </Typography>
          {selected === "headless" ? <Typography variant="body2" sx={{
          mt: 1
        }} color="text.secondary">
              {t("schema.headlessModeDescription")}
            </Typography> : <Typography variant="body2" sx={{
          mt: 1
        }} color="text.secondary">
              {t("schema.hybridModeDescription")}
            </Typography>}
        </DialogTitle>
        <DialogActions data-sentry-element="DialogActions" data-sentry-source-file="HeadlessSwitcher.tsx">
          <Button onClick={() => setSelected(null)} color="primary" data-sentry-element="Button" data-sentry-source-file="HeadlessSwitcher.tsx">
            {t("common.cancel")}
          </Button>
          <Button loading={isLoading} variant="contained" onClick={handleSwitch} data-sentry-element="Button" data-sentry-source-file="HeadlessSwitcher.tsx">
            {t("schema.switchToMode", {
            mode: startCase(selected)
          })}
          </Button>
        </DialogActions>
      </Dialog>
    </>;
};